module.exports = __webpack_public_path__ + "13fb7755ead4829cf214b927739a88f5.png";


/*****************
 ** WEBPACK FOOTER
 ** ./client/components/store-thumbnail/images/store_placeholder.png
 ** module id = 1300
 ** module chunks = 0
 **/